import styled from 'styled-components';
import ReckewegBackground from '../../assets/Lines/reckeweg-background.png'
import TegorBackground from '../../assets/Lines/tegor-background.png'
import HelixorBackground from '../../assets/Lines/helixor-background.png'
import SymbioBackground from '../../assets/Lines/symbio-background.png'
import RegenhialBackground from '../../assets/Lines/regenhial-background.png'

export const Container = styled.div`
  background-image: url(${props => props.background === 'dr-reckeweg' ? ReckewegBackground : props.background === 'tegor' ? TegorBackground : props.background === 'helixor' ? HelixorBackground : props.background === 'symbio' ? SymbioBackground : RegenhialBackground }) ;
  background-size: cover;
  background-position: center;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 20px;
  height: ${({ expanded }) => (expanded ? '100vh' : '150px')};
  transition: height 0.3s ease-in-out;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${({ expanded }) => (expanded ? 'space-between' : 'center')};
  align-items: center;
  gap: 20px;
  height: 100%;
  align-items: center;
`;

export const Logo = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10%;

  img{
    width: 10em;
  }
`;

export const Title = styled.h1`
  font-size: 5.2rem;
  line-height: 0.9em;
  font-weight: bold;
  text-transform: capitalize;
  letter-spacing: 4px;
  margin-top: -10%;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 2.2rem;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 2.2rem;
  }
`;

export const Options = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  font-size: 0.9rem;
  font-weight: 400;
  margin-bottom: 50px;

  @media (max-width: 550px) {
    /* Phones */
    font-size: 0.7rem;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    font-size: 0.7rem;
  }
`;

export const Option = styled.a.attrs(props => ({
  as: props.as || 'a'
}))`
  color: white;
  font-size: 1.3em;
  padding: 5px 10px;
  cursor: pointer;
  text-decoration: none;

  &:hover{
    text-decoration: underline;
  }
`;

export const LogoTitle = styled.div`

`